<template>
  <transition name="loading-animation">
    <div v-if="$getUi().appLoading" class="loading-animation">
      <div class="loading-animation__cog">
        <Icon :icon="['fas', $getUi().appLoading]"/>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  created () {
    this.$setUi({ appLoading: null })
  },
  beforeDestroy () {
    this.$removeUi([ "appLoading" ])
  }
}
</script>

<style lang="scss">
.loading-animation {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 100;
    background: rgba(black, 0.35);
    height: 100vh;
    width: 100%;
    top: 0;
    left: 0;
    .loading-animation__cog {
        animation: loading-animation-appear 0.45s 0.05s backwards;
        @keyframes loading-animation-appear {
            0% {
                opacity: 0;
                transform: scale(0.5);
            }
            60% {
                opacity: 1;
                transform: scale(1.2);
            }
            100% {
                opacity: 1;
                transform: none;
            }
        }
        svg {
            font-size: 125px;
            @media only #{$mediaTablet} {
                font-size: 105px;
            }
            color: $bg;
            animation: loading-animation-spin 3.5s linear infinite;
            @keyframes loading-animation-spin {
                from {
                    transform: none;
                }
                to {
                    transform: rotate(360deg);
                }
            }
        }
    }
}
.loading-animation-enter, .loading-animation-leave-to {
    opacity: 0;
}
.loading-animation-enter-to, .loading-animation-leave {
    opacity: 1;
}
.loading-animation-enter-active {
    transition: opacity 0.2s;
}
.loading-animation-leave-active {
    transition: opacity 0.1s;
}
</style>
